import axios from 'axios'

export default class IALoadMore {
    /**
     * @param {Object} options This is an object to instanciate the load more
     * @param {String} options.post_type You have to provide the post type to load
     * @param {Number} options.page_to_load Number of page to load
     * @param {HTMLElement} options.item Provide the item to clone
     * @param {Number} options.per_page Number of element to display
     * @param {Number} options.maxpage Maximum of pages
     * @param {String} options.lang Provide the lang
     * @param {String} [options.image] Selector of the image
     * @param {String} [options.title] Selector of the title
     * @param {String} [options.excerpt] Selector of excerpt
     * @param {String} [options.date] Selector of date
     */
    constructor(
        options = {
            post_type: '',
            page_to_load: 0,
            item : new HTMLElement,
            per_page: 0,
            maxpage: 0,
            lang: '',
            image: '',
            title: '',
            excerpt: '',
            date: '',
        }
    ) {
        this.options = options
        if(options.page_to_load <= options.maxpage){
            this.getPosts()
            document.querySelector('.ia-block-post').dataset.page = Number(document.querySelector('.ia-block-post').dataset.page) + 1
            if(options.page_to_load == options.maxpage){
                options.item.parentElement.parentElement.querySelector('.wp-block-buttons button').disabled = true;
                options.item.parentElement.parentElement.querySelector('.wp-block-buttons').classList.add('is-hidden')
            }
        }else{
            options.item.parentElement.parentElement.querySelector('.wp-block-buttons button').disabled = true;
            options.item.parentElement.parentElement.querySelector('.wp-block-buttons').classList.add('is-hidden')
        }
    }

    async getPosts() {
        const url = '/wp-json/wp/v2/'+ this.options.post_type 
            + '?per_page='+ this.options.per_page 
            + '&page=' + this.options.page_to_load 
            + '&lang=' + this.options.lang

        return await axios.get(url).then((response) => {
            let listResponse = response.data;
            listResponse.forEach(item => {
                console.log(item)
                let clonedItem = this.options.item.cloneNode(true)
                
                if(this.options.title != undefined){
                    const title = item.title.rendered
                    clonedItem.querySelector(this.options.title).textContent = title
                }
                if(this.options.excerpt != undefined){
                    const excerpt = item.excerpt.rendered
                    clonedItem.querySelector(this.options.excerpt).innerHTML = excerpt
                }
                if(this.options.date != undefined){
                    const date = item.date.rendered
                    clonedItem.querySelector(this.options.date).innerHTML = date
                }
                if(this.options.image != undefined){
                    const image = this.getImage(item.featured_media) 
                        || window.location.host + '/wp-content/themes/iawp-child/assets/img/placeholder-horizontal.png' 
                        || window.location.host + '/wp-content/themes/iawp/assets/img/placeholder-horizontal.png'
                    image.then(imageSrc => {
                        clonedItem.querySelector(this.options.image).src = imageSrc
                    })
                }
                
                clonedItem.querySelectorAll('a').forEach(a => a.href = item.link)

                const parent = this.options.item.parentElement;
                parent.appendChild(clonedItem);
            });
        })
    }

    async getImage(id) {
        return await axios.get('/wp-json/wp/v2/media/' + id).then((response) => {
            let imageSize = response.data.media_details.sizes;
            imageSize = (imageSize.large)?imageSize.large:imageSize.full
            return imageSize.source_url
        }).catch((error)=>{
            return window.location.host + '/wp-content/themes/iawp/assets/img/placeholder-horizontal.png'
        })
    }
}